export default "__VITE_ASSET__KReyIJC$__"